<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">非券订单佣金列表</div>
    </div>
    <non-coupon-commission-list />
  </div>
</template>

<script>
import NonCouponCommissionList from './components/nonCouponCommissionList.vue'

export default {
  name: 'DouyinPoiNonCouponCommission',
  components: {
    NonCouponCommissionList
  }
}
</script>

<style scoped lang="less">
.header {
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/nonCouponCommission.vue